import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import createPalette from '@material-ui/core/styles/createPalette'
import createTypography from '@material-ui/core/styles/createTypography'
import createMixins from '@material-ui/core/styles/createMixins'
import createBreakpoints from '@material-ui/core/styles/createBreakpoints'
import spacing from '@material-ui/core/styles/spacing'

const palette = createPalette({
  background: {
    default: '#ffffff',
  },
  primary: {
    contrastText: '#ffffff',
    light: '#81c6ff',
    main: '#67b4ff',
    dark: '#2485cb',
  },
  secondary: {
    contrastText: '#ffffff',
    light: '#606062',
    main: '#363638',
    dark: '#101012',
  },
  text: {
    primary: '#363638',
    secondary: '#636363',
  },
})

const fontSize = 14
const fontFamily = '"Open Sans", sans-serif'
const fontWeightLight = 300
const fontWeightRegular = 400
const fontWeightMedium = 600

const typography = createTypography(palette, {
  useNextVariants: true, // @todo Remove in next major release
  fontSize,
  fontFamily,
  fontWeightLight,
  fontWeightRegular,
  fontWeightMedium,
  button: {
    textTransform: 'none',
  },
})

const breakpoints = createBreakpoints({})

const mixins = createMixins(breakpoints, spacing, {
  toolbar: {
    minHeight: 48,
    [breakpoints.up('sm')]: {
      minHeight: 100,
    },
  },
})

export default () => createMuiTheme({
  palette,
  typography,
  breakpoints,
  mixins,
})
